import type { InterventionTabModulesProps } from "./intervention-tab-modules.type";

import InterventionTabModules from "./intervention-tab-modules.component";

export type { InterventionTabModulesProps };
export default InterventionTabModules;
